import { http } from './http'

export interface EmailSingleFileRequest {
  recipient_email: string
  filename: string
  comment?: string
}

export interface EmailAllFilesRequest {
  recipient_email: string
  comment?: string
}

export interface EmailResponse {
  success: boolean
  attached_files?: string[]
  failed_files?: string[]
  message?: string
}

/**
 * Отправить один файл по email
 */
export async function sendSingleFileEmail(
  orderId: string, 
  data: EmailSingleFileRequest
): Promise<EmailResponse> {
  const formData = new FormData()
  formData.append('recipient_email', data.recipient_email)
  formData.append('filename', data.filename)
  if (data.comment && data.comment.trim()) {
    formData.append('comment', data.comment.trim())
  }



  const response = await http.post(`/files/send-single-file-email/${orderId}`, formData)
  return response.data
}

/**
 * Отправить все файлы заказа по email
 */
export async function sendAllFilesEmail(
  orderId: string, 
  data: EmailAllFilesRequest
): Promise<EmailResponse> {
  const formData = new FormData()
  formData.append('recipient_email', data.recipient_email)
  if (data.comment && data.comment.trim()) {
    formData.append('comment', data.comment.trim())
  }



  const response = await http.post(`/files/send-files-email/${orderId}`, formData)
  return response.data
}

/**
 * Отправить файл из чата по email
 */
export async function sendChatFileEmail(
  orderId: string, 
  data: EmailSingleFileRequest
): Promise<EmailResponse> {
  const formData = new FormData()
  formData.append('recipient_email', data.recipient_email)
  formData.append('filename', data.filename)
  if (data.comment) {
    formData.append('comment', data.comment)
  }

  const response = await http.post(`/files/send-chat-file-email/${orderId}`, formData)
  return response.data
}
